<template>
  <div class="ma-3">
    <v-card elevation="10">
      <v-toolbar class="mb-6" :color="$colors[0]" dark>
        <span class="pl-0">Electricité professionnel</span>
      </v-toolbar>
      <FormulaireDeCotation class="pa-4" @sendDataToParent="replireDataFromCotation" />
      <ListeDesPropositions
        class="pa-4"
        :infosCompteurProps="infosCompteur"
        :marge="marge"
        :optionTarifaire="optionTarifaire"
        :parametreCompteur="parametreCompteur"
        :Propositions="Propositions"
        :SocieteData="SocieteData"
        :enedisData="enedisData"
        :numCompteur="numCompteur"
        :turpeData="turpeData"
        :taxeData="taxeData"
        :typeCompteur="typeCompteur"
        :fournisseurActuelle="fournisseurActuelle"
        :selected="selected"
        :listCompteur="listCompteur"
        :donnerCompteur="donnerCompteur"
        :donneDeCotation="donneDeCotation"
        :id_historique_cotation="id_historique_cotation"
        :date_debut="date_debut"
      />
    </v-card>
  </div>
</template>
<script>
import FormulaireDeCotation from "../../components/proposition-professionnels-elec/newElecCalcul/newFormulaireDeCotation.vue";
import ListeDesPropositions from "../../components/proposition-professionnels-elec/newElecCalcul/newListePropositions.vue";
import "./css/cotationPro.css";

import axios from "axios";
import dialogeModal from "../../components/ui/dialogeModal.vue";
export default {
  name: "demandeDeCotationElecPro",
  components: {
    FormulaireDeCotation,
    ListeDesPropositions,
    dialogeModal,
  },
  data() {
    return {
      infosCompteur: null,
      parametreCompteur: null,
      Propositions: [],
      SocieteData: [],
      marge:null,
      optionTarifaire: "",
      enedisData: [],
      donneDeCotation: [],
      numCompteur: null,
      turpeData: [],
      taxeData: [],
      typeCompteur: null,
      panel: [],
      fournisseurActuelle: null,
      selected: [],
      listCompteur: [],
      donnerCompteur: null,
      id_historique_cotation: null,
      date_debut:"",
    };
  },
  async created() {
    var whoIam = "";
    await this.whoIAm(this.getToken("token")).then((data) => {
      whoIam = data;
    });
    if (whoIam == "noToken") {
      localStorage.removeItem("vendeurName");
      localStorage.removeItem("typeUser");
      localStorage.removeItem("token");
      this.$router.push("/login");
    } else {
      localStorage.setItem("typeUser", whoIam);
    }
  },
  methods: {
    replireDataFromCotation({
      infosCompteur,
      donneDeCotation,
      optionTarifaire,
      marge,
      parametreCompteur,
      Propositions,
      SocieteData,
      enedisData,
      numCompteur,
      turpeData,
      taxeData,
      typeCompteur,
      fournisseurActuelle,
      selected,
      listCompteur,
      donnerCompteur,
      id_historique_cotation,
      date_debut
      
    }) {
      this.infosCompteur = infosCompteur;
      this.donneDeCotation = donneDeCotation;
      this.parametreCompteur = parametreCompteur;
      this.Propositions = Propositions;
      this.SocieteData = SocieteData;
      this.enedisData = enedisData;
      this.numCompteur = numCompteur;
      this.turpeData = turpeData;
      this.taxeData = taxeData;
      this.optionTarifaire = optionTarifaire;
      this.marge = marge;
      this.typeCompteur = typeCompteur;
      this.fournisseurActuelle = fournisseurActuelle;
      this.listCompteur = listCompteur;
      this.donnerCompteur = donnerCompteur;
      this.id_historique_cotation = id_historique_cotation;
      this.date_debut = date_debut;
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@700&display=swap");
</style>
